import { render, staticRenderFns } from "./BgPurchaseDetails.vue?vue&type=template&id=f0de7236"
import script from "./BgPurchaseDetails.vue?vue&type=script&lang=js"
export * from "./BgPurchaseDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports